import { useState, useEffect } from 'react'
import { fetchBillingDashboardStats } from '../services/billing/dashboardStatsCache'

/**
 * Returns the count of draft billing invoices for the nav/page badge, sharing
 * one /api/billing/dashboard-stats request with the billing dashboard via the
 * dashboard-stats cache. The badge is non-critical, so failures resolve to 0.
 * @param {boolean} enabled - Skip the fetch when false (e.g. non-admins)
 * @returns {number} Draft invoice count
 */
const useBillingDraftCount = (enabled = true) => {
  const [draftCount, setDraftCount] = useState(0)

  useEffect(() => {
    if (!enabled) return undefined
    let active = true
    fetchBillingDashboardStats()
      .then((data) => { if (active) setDraftCount(data?.kpis?.draft_count || 0) })
      .catch(() => { if (active) setDraftCount(0) })
    return () => { active = false }
  }, [enabled])

  return draftCount
}

export default useBillingDraftCount
